/**
 * The storefront palette. White surfaces, orange accent by default — a
 * boutique's own colours (Admin > Boutiques) override primary/secondary below.
 */
export const PALETTE = {
  // Orange ramp
  orange50: '#ffe3d6',
  orange100: '#ffac86',
  orange: '#ff4d00',
  orangeDark: '#7a2c0f',
  orangeCta: '#fc7303',

  // Neutrals
  white: '#ffffff',
  surface: '#fcfcfc',
  surfaceAlt: '#f6f6f6',
  border: '#ededed',
  muted: '#6f6f6f',

  // Text
  text: '#1c1917',
  textSecondary: '#78716c',
  textMuted: '#a8a29e',

  // Status
  success: '#03b658',
  error: '#f12727',
  warning: '#f59e0b',
};

// What the rest of the app calls "primary" / "secondary" — used for buttons,
// links and accents, so these must stay visible against white card surfaces.
// A boutique with its own colours set overrides these at runtime.
export const PRIMARY_COLOR = PALETTE.orange;
export const SECONDARY_COLOR = PALETTE.orangeCta;

export default PALETTE;
